import { gql } from '@apollo/client';
import orgsAndUnitsFragment from '@shared/queries/orgsAndUnitsFragment';

const MOVE_LICENSE_ORGANIZATIONS = gql`
  query MoveLicenseOrganizations($moveLicenseType: Int!, $orgId: Int) {
    moveLicenseOrganizations(moveLicenseType: $moveLicenseType, orgId: $orgId) {
      ...OrgAndUnitsFields
    }
  }
  ${orgsAndUnitsFragment}
`;

export default MOVE_LICENSE_ORGANIZATIONS;
